import React from 'react';
import Root from './levels/Root';
import RootClass from './levels/RootClass';
import EquipmentType from './levels/EquipmentType';
import PointList from './levels/PointList';
import PointType from './levels/PointType';
import Measurement from './levels/Measurement';
import Relationships from './levels/Relationships';
import Location from './levels/Location';
import ModelingState from './levels/ModelingState';
import Glossary from './levels/Glossary';

const getObj = (path, model) => {
  let found = model;
  for (let i = 0; i < path.length; i += 1) {
    const nextPath = decodeURIComponent(path[i]);
    if (!nextPath) break;
    const next = found?.children?.find((c) => c.link === nextPath);
    if (!next) break;
    found = next;
  }
  return found;
};

const renderObject = (path, model, base, queryParams) => {
  const [rootType, first, second] = path;
  if (rootType == null) return <Root />;

  const isTopLevel = first == null && second == null;
  if (isTopLevel && rootType !== 'points') return <RootClass type={rootType} />;

  const modelObj = getObj(path, model);

  if (rootType === 'equipment') {
    if (first != null) return <EquipmentType equipment={modelObj} />;
  }
  if (rootType === 'points') {
    if (first != null && second != null) {
      return <PointType base={base} ptName={second} />;
    }
    return <PointList base={base} queryParams={queryParams} />;
  }
  if (rootType === 'measurements' && first != null) {
    return <Measurement measurement={modelObj} base={base} />;
  }
  if (rootType === 'relationships') {
    return <Relationships attr={first} />;
  }
  if (rootType === 'location') {
    return <Location attr={first} />;
  }
  if (rootType === 'modeling') {
    return <ModelingState attr={first} />;
  }
  if (rootType === 'glossary') {
    return <Glossary attr={first} />;
  }

  return 'Something went wrong, please try again in a minute';
};

const ClassViewer = ({ path, model, base, queryParams }) => (
  <div className="class-viewer root">
    <div className={`obj ${path.join(' ')}`}>{renderObject(path, model, base, queryParams)}</div>
  </div>
);

export default ClassViewer;
